export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL?.trim().replace(/\/+$/, "") ?? "",
  gameServerUrl: import.meta.env.VITE_GAME_SERVER_URL?.trim().replace(/\/+$/, "") ?? "",
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL?.trim() ?? "",
  supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() ?? "",
};

export const missingMultiplayerServices = [
  ...(!config.gameServerUrl ? ["VITE_GAME_SERVER_URL"] : []),
  ...(!config.supabaseUrl ? ["VITE_SUPABASE_URL"] : []),
  ...(!config.supabasePublishableKey ? ["VITE_SUPABASE_PUBLISHABLE_KEY"] : []),
];

export const multiplayerConfigured = missingMultiplayerServices.length === 0;

export function multiplayerDisabledMessage(): string {
  if (multiplayerConfigured) return "";
  return `Çevrimiçi oyun kapalı. Eksik yapılandırma: ${missingMultiplayerServices.join(", ")}.`;
}

export function endpoint(path: string): string {
  const base = config.apiBaseUrl || config.gameServerUrl;
  if (!base) throw new Error("GAME_SERVER_URL_MISSING");
  return new URL(path, `${base}/`).toString();
}
